import {
  Autocomplete,
  getOptionAsValue,
  withNamespace,
} from "components/Form/FormikControls";
import React, { useMemo } from "react";
import { sortBy } from "lodash";
import { useSelector } from "react-redux";
import { getDefaultBillingSettings } from "selectors";

interface FieldProps {
  disabled?: boolean;
  label?: string;
  name?: string;
  namespace?: string;
  placeholder?: string;
  required?: boolean;
  tooltip?: string;
}

export const BankingDetailField = ({
  namespace: ns,
  label,
  name = "bankingDetailId",
  required = false,
  disabled = false,
  placeholder = undefined,
  tooltip = undefined,
}: FieldProps) => {
  const billingSettings = useSelector(getDefaultBillingSettings);

  const options = useMemo(
    () =>
      sortBy(
        billingSettings.paymentBankingDetails?.map(bankingDetail => ({
          value: bankingDetail.id,
          label:
            bankingDetail.accountName ||
            bankingDetail.payid ||
            bankingDetail.chequePayableTo,
        })),
        "label",
      ),
    [billingSettings.paymentBankingDetails],
  );

  return (
    <Autocomplete
      name={withNamespace(ns, name)}
      options={options}
      required={required}
      getOptionValue={getOptionAsValue}
      disableClearable
      label={label}
      disabled={disabled}
      placeholder={placeholder}
      tooltip={tooltip}
    />
  );
};
